/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { initPaymentResponseSchema } from "./initPaymentResponseSchema.ts";
import { mobileOrderInitPaymentRequestSchema } from "./mobileOrderInitPaymentRequestSchema.ts";

export const mobileOrderInitPaymentStatus201Schema = initPaymentResponseSchema.describe("url is nullable for payments from kiosk");

export const mobileOrderInitPaymentResponseSchema = mobileOrderInitPaymentStatus201Schema;

export const mobileOrderInitPaymentDataSchemaJson = mobileOrderInitPaymentRequestSchema;

export const mobileOrderInitPaymentDataSchemaXml = mobileOrderInitPaymentRequestSchema;

export const mobileOrderInitPaymentDataSchema = z.union([mobileOrderInitPaymentDataSchemaJson, mobileOrderInitPaymentDataSchemaXml]);
